// api/users.js
import axios from "axios";
import config from "../config";

const authHeaders = () => {
  const token = localStorage.getItem("token");
  return { Authorization: `Bearer ${token || ""}` };
};

// 🔍 Tìm user theo email
export const searchUserByEmail = async (email) => {
  try {
    const res = await axios.get(`${config.apiBaseUrl}/users/search`, {
      headers: authHeaders(),
      params: { keyword: email },
    });

    if (!res.data.exists) {
      console.warn("⚠️ User không tồn tại:", email);
    }

    return res.data; // { exists: true/false, data?, message? }
  } catch (error) {
    console.error("❌ Lỗi tìm user:", error.message);
    return { error: "Không thể kết nối server" };
  }
};

// ➕ Tạo user mới
export const createUser = async (userData) => {
  try {
    const res = await axios.post(`${config.apiBaseUrl}/users`, userData, {
      headers: {
        ...authHeaders(),
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("❌ Lỗi tạo user:", error.response?.data || error.message);
    throw new Error(error.response?.data?.error || "Tạo user thất bại!");
  }
};
